import React, { useMemo } from 'react';
import { EmojiContextProvider } from './EmojiContextProvider';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
/**
 * EmojiCommonProvider will provide emojiProvider to children,
 * which will be used to access Emoji Resource to find emoji, filter emoji, check if upload is supported, etc.
 *
 * Example usage:
 * const emojiResource = new EmojiResource(resourceConfig)
 * <EmojiCommonProvider emojiProvider={emojiResource} />
 */
export var EmojiCommonProvider = function EmojiCommonProvider(props) {
  var emojiContextValue = useMemo(function () {
    return props.emojiProvider ? {
      emoji: {
        emojiProvider: props.emojiProvider
      }
    } : undefined;
  }, [props.emojiProvider]);
  if (!!emojiContextValue && expValEquals('cc_complexit_fe_emoji_stability', 'isEnabled', true)) {
    return /*#__PURE__*/React.createElement(EmojiContextProvider, {
      emojiContextValue: emojiContextValue
    }, props.children);
  } else if (props.emojiProvider) {
    return /*#__PURE__*/React.createElement(EmojiContextProvider, {
      emojiContextValue: {
        emoji: {
          emojiProvider: props.emojiProvider
        }
      }
    }, props.children);
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, props.children);
  }
};